import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { ConversationAnalysisStyles } from "./ConversationAnalysisStyles";
import ChatBubbleOutlineRoundedIcon from "@mui/icons-material/ChatBubbleOutlineRounded";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import PieChartOutlinedIcon from "@mui/icons-material/PieChartOutlined";
import { useAppSelector } from "../../store/hooks";
import { RootState } from "../../store/store";

const ConversationMetrics: React.FC = () => {
  const isMobile = useMediaQuery("(max-width:767px)");

  const { conversationMetrics } = useAppSelector(
    (state: RootState) => state.conversationAnalysis
  );
  return (
    <Box
      sx={{
        ...ConversationAnalysisStyles.metricsContainer,
        flexDirection: isMobile ? "column" : "row",
      }}
      id="conversation_metrics_container"
      data-test-id="conversation_metrics_container"
      aria-label="Conversation Metrics"
    >
      <Box 
        sx={ConversationAnalysisStyles.metricCard}
        id="conversation_metrics_total_messages"
        data-test-id="conversation_metrics_total_messages"
        aria-label="Total Messages Metric"
      >
        <Box 
          sx={ConversationAnalysisStyles.metricCardTopContainer}
          id="conversation_metrics_total_messages_header"
          data-test-id="conversation_metrics_total_messages_header"
          aria-label="Total Messages Header"
        >
          <Typography 
            sx={ConversationAnalysisStyles.cardHeading}
            id="conversation_metrics_total_messages_title"
            data-test-id="conversation_metrics_total_messages_title"
            aria-label="Total Messages"
          >
            Total Messages
          </Typography>
          <ChatBubbleOutlineRoundedIcon fontSize="small" />
        </Box>
        <Box 
          sx={ConversationAnalysisStyles.metricCardBottomContainer}
          id="conversation_metrics_total_messages_value"
          data-test-id="conversation_metrics_total_messages_value"
          aria-label={`Total Messages: ${conversationMetrics?.totalMessages || 0}`}
        >
          <Typography sx={ConversationAnalysisStyles.cardContent}>
            {conversationMetrics?.totalMessages || 0}
          </Typography>
        </Box>
      </Box>
      <Box 
        sx={ConversationAnalysisStyles.metricCard}
        id="conversation_metrics_total_feedback"
        data-test-id="conversation_metrics_total_feedback"
        aria-label="Total Feedback Metric"
      >
        <Box 
          sx={ConversationAnalysisStyles.metricCardTopContainer}
          id="conversation_metrics_total_feedback_header"
          data-test-id="conversation_metrics_total_feedback_header"
          aria-label="Total Feedback Header"
        >
          <Typography 
            sx={ConversationAnalysisStyles.cardHeading}
            id="conversation_metrics_total_feedback_title"
            data-test-id="conversation_metrics_total_feedback_title"
            aria-label="Total Feedback"
          >
            Total Feedback
          </Typography>
          <ThumbUpOffAltIcon />
        </Box>
        <Box 
          sx={ConversationAnalysisStyles.metricCardBottomContainer}
          id="conversation_metrics_total_feedback_value"
          data-test-id="conversation_metrics_total_feedback_value"
          aria-label={`Total Feedback: ${conversationMetrics?.totalFeedback || 0}`}
        >
          <Typography sx={ConversationAnalysisStyles.cardContent}>
            {conversationMetrics?.totalFeedback || 0}
          </Typography>
        </Box>
      </Box>
      <Box 
        sx={ConversationAnalysisStyles.metricCard}
        id="conversation_metrics_positive_feedback"
        data-test-id="conversation_metrics_positive_feedback"
        aria-label="Positive Feedback Metric"
      >
        <Box 
          sx={ConversationAnalysisStyles.metricCardTopContainer}
          id="conversation_metrics_positive_feedback_header"
          data-test-id="conversation_metrics_positive_feedback_header"
          aria-label="Positive Feedback Header"
        >
          <Typography 
            sx={ConversationAnalysisStyles.cardHeading}
            id="conversation_metrics_positive_feedback_title"
            data-test-id="conversation_metrics_positive_feedback_title"
            aria-label="Positive Feedback"
          >
            Positive Feedback
          </Typography>
          <PieChartOutlinedIcon />
        </Box>
        <Box 
          sx={ConversationAnalysisStyles.metricCardBottomContainer}
          id="conversation_metrics_positive_feedback_value"
          data-test-id="conversation_metrics_positive_feedback_value"
          aria-label={`Positive Feedback: ${conversationMetrics?.positiveFeedback || 0}%`}
        >
          <Typography sx={ConversationAnalysisStyles.cardContent} id="conversation_metrics_positive_feedback_value_text" data-test-id="conversation_metrics_positive_feedback_value_text" aria-label={`Positive Feedback: ${conversationMetrics?.positiveFeedback || 0}%`}>
            {conversationMetrics?.positiveFeedback
              ? `${conversationMetrics.positiveFeedback}%`
              : "0%"}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ConversationMetrics;
